export enum CollectionSorting {
  DEFAULT = 'COLLECTION_DEFAULT',
  TITLE = 'title',
  PRICE_ASCENDING = 'price-ascending',
  PRICE_DESCENDING = 'price-descending',
  NEW = 'new',
  BEST_SELLING = 'best-selling',
}

/** Sorting options offered by the CDP filter bar. Lives here so translation
 * bundles can reference the keys without importing the component. */
export const SortOptions = {
  placeholder: 'placeholder',
  relevance: 'relevance',
  rating: 'rating',
  'price-asc': 'price-asc',
  'price-desc': 'price-desc',
  acceptance: 'acceptance',
} as const;

export type SortOptions = (typeof SortOptions)[keyof typeof SortOptions];
